module.exports = __webpack_public_path__ + "202408221624/img/img_card_top_2.193cd710.png";